const typ = { t: 'Typ', name: 'podkategoria-pojazdu', hint: { url: '/construction_subcategory', select: true }}
export default typ
